import { createFileRoute } from '@tanstack/react-router';
import { ProjectShell } from '../features/projects/project-shell';
export const Route = createFileRoute('/manage/$companySlug/projects/$projectId')({
  component: RouteComponent,
});
function RouteComponent() {
  const { companySlug, projectId } = Route.useParams();
  return <ProjectShell companySlug={companySlug} projectId={projectId} />;
}
